import algoliasearch from 'algoliasearch/lite';

function emptySearchResponse(requests) {
  var list = Array.isArray(requests) ? requests : [];
  return {
    results: list.map(function() {
      return { hits: [], nbHits: 0, page: 0, nbPages: 0, hitsPerPage: 0, processingTimeMS: 0, query: '' };
    }),
  };
}

function emptySearchClient() {
  return {
    search: function(requests) {
      return Promise.resolve(emptySearchResponse(requests));
    },
    initIndex: function() {
      return {
        search: function() {
          return Promise.resolve({ hits: [] });
        },
      };
    },
  };
}

export function getSearchClient() {
  if (!process.env.VUE_APP_ALGOLIA_APP_ID || !process.env.VUE_APP_ALGOLIA_SEARCH_KEY) {
    if (process.env.NODE_ENV !== 'development') {
      throw new Error('Algolia App ID and Search-Only API Key must be set in environment variables');
    }
    console.error('Algolia search keys are missing. Shop search is disabled in local development.');
    return emptySearchClient();
  }

  return algoliasearch(process.env.VUE_APP_ALGOLIA_APP_ID, process.env.VUE_APP_ALGOLIA_SEARCH_KEY);
}
